export default __webpack_public_path__ + "static/media/thunderstorm-night.2bd32031.svg";